(function () {
    'use strict';

    angular
        .module('ib-new-seat-map-module')
        .directive('ibOldFlightMap', ibOldFlightMap);

    ibOldFlightMap.$inject = ['$window', '$rootScope', 'localStorageService'];

    function ibOldFlightMap ($window, $rootScope, localStorageService) {
        // Usage: <div ib-old-flight-map>
        //
        // Creates: auxiliar functionality to seats map of the rendered flight
        //
        return {
            restrict: 'A',
            transclude: false,
            bindToController: true,
            scope: {
                seatsModel: '=',
                currentPassenger: '=',
                templateUrl: '@',
                passengers: '<',
                aircraftCode: '<',
                seatViewInfo: '<'
            },
            templateUrl: function (element, attrs) {
                return attrs.templateUrl || $rootScope.routes.templates + 'ib-modal-old-seats-map-infinite-scroll.html';
            },
            controller: 'ibOldFlightMapController',
            controllerAs: 'mapSeats',
            link: link
        };

        function link ($scope, element, attrs) {
            /* Tooltip Map*/


            /* Resize responsive tooltip */
            angular.element($window).bind('resize', () => {
                const $tooltip = angular.element('.ib-map-tooltip');
                if ($tooltip.css('display') === 'block') {
                    $tooltip.css('display', 'none');
                }
            });

            /* Document click, close tooltip */
            angular.element($window).bind('click', (e) => {
                // Variables
                const $tooltip = angular.element('.ib-map-tooltip'),
                    $map = angular.element('.ib-map');
                const $tooltipTouch = angular.element('#toolTipTouch');


                const $target = angular.element(e.target),
                    $eventTooltip = $target.closest('.ib-map-tooltip'),
                    $eventSeat = $target.closest('.ib-map__column'),
                    $eventGap = $target.closest('.ib-map__column--gap');

                const $eventTooltipTouch = $target.closest('.ib-map-tooltip-touch');

                if ((!$eventTooltip || $eventTooltip.length === 0) && (!$eventSeat || $eventSeat.length === 0)) {
                    if ($tooltip.css('display') === 'block') {
                        $tooltip.css('display', 'none');
                    }
                }

                if ((!$eventTooltipTouch || $eventTooltipTouch.length === 0) && (!$eventSeat || $eventSeat.length === 0)) {
                    if ($tooltipTouch.css('display') === 'block') {
                        angular.element('#toolTipTouch').remove();
                    }
                }

                if ($eventGap && $eventGap.length > 0) {
                    if ($tooltip.css('display') === 'block') {
                        $tooltip.css('display', 'none');
                    }
                }
            });

        }
    }
})();
